import React, { useContext, useEffect, useState, useRef } from 'react';
import {
  Typography,
  IconButton,
  Grid,
  Card,
  CardContent,
  Collapse,
  useMediaQuery,
  Box,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ExpandIcon } from 'component/OwnerCard/OwnerCard';
import { getMoxoBinder } from 'api/rcpapiService';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Moxochatloop from './Moxochatloop';
import { useTheme } from '@emotion/react';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { datacontextsoli } from 'modules/private/BuyerSolicitor/BuyerSolicitor';
import {
  APP_SCALE,
  MOXO_USER_ID,
  RCP_API_URL,
  USER_MAIL_ID,
} from 'constant/app.config';
import { init } from '@YaaryAi/moxo-web-fe';
import { createPortal } from 'react-dom';

function Moxochat({
  open,
  onClose,
  binderId,
  isgallery,
  issolicitor,
  animationType,
  hasAnimated,
  onAnimateComplete = () => {},
  setMessage,
  setChangestab,
}) {
  const history = useHistory();
  const sdkRef = useRef(null);
  const portalRootRef = useRef(null);
  const sdkContainerRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    portalRootRef.current = document.getElementById('overlay-root');
    setMounted(true);
  }, []);
  // Always call useContext, even if it's not used in all scenarios
  const context = useContext(issolicitor ? datacontextsoli : datacontext);

  // Destructure only when not in gallery mode
  const {
    setMsgcount,
    moxochatloop,
    setMoxochatloop,
    ischatopen,
    setIschatopen,
    setShowMessage,
    setMessagedata,
  } = context || {}; // Provide a default empty object to avoid destructuring from undefined
  const token = localStorage.getItem('moxoDetail');
  const bearerToken = JSON.parse(token);
  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const usermail = userDetail?.userEmail;
  // Use media query to check screen width
  const theme = useTheme();
  const isLargeScreen = useMediaQuery('(min-width:1000px)');
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesxl = useMediaQuery(theme.breakpoints.up('xl'));
  const { setIsBinderChatOpen } = useContext(PropertyContext);
  const [isAnimated, setIsAnimated] = useState(false);
  const [isClosingDown, setIsClosingDown] = useState(false);
  const animationRef = useRef(false);

  // useEffect(() => {
  //   if (matches500) {
  //     onClose();
  //     window.open(
  //       `com.comm-app://LoginPage?mailid=${usermail}&binder=${
  //         isgallery ? binderId : ischatopen
  //       }`,
  //       '_blank'
  //     );
  //   }
  // }, []);

  // Trigger animation when 'open' changes to true
  useEffect(() => {
    if (open && !isAnimated) {
      setIsAnimated(true);
    }
  }, [open, isAnimated]);

  // Trigger the onAnimateComplete callback after the animation is done
  useEffect(() => {
    if (open && !hasAnimated && !animationRef.current) {
      setIsAnimated(true);
      animationRef.current = true;
      onAnimateComplete();
    }
  }, [open, hasAnimated, onAnimateComplete]);

  const [isAnimating, setIsAnimating] = useState(false);

  // Function to handle closing the chat with animation
  const handleClose = (finding) => {
    setIsClosingDown(true);

    setTimeout(() => {
      onClose();
      setIsClosingDown(false);
    }, 1200);

    if (isgallery) {
      onClose(false);
    } else {
      getMoxoBinder().then((resp) => {
        setMsgcount(resp?.data?.unread_feeds);
      });

      onClose(false);

      if (finding !== 'minimize') {
        setMoxochatloop((prevItems) =>
          prevItems.filter((item) => item !== ischatopen)
        );
      }

      setIschatopen('');
      setIsBinderChatOpen(false);
    }
  };

  // styles for animation
  const useStyles = makeStyles((theme) => ({
    innericons: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
    },
    slideInRight: {
      animation:
        open && !isAnimated ? '$slideInRight 0.5s ease-in-out' : 'none',
      animationFillMode: 'forwards',
    },
    '@keyframes slideInRight': {
      '0%': {
        transform: 'translateX(100%)',
      },
      '100%': {
        transform: 'translateX(0)',
      },
    },
    slideInBottom: {
      animation: open && !hasAnimated ? '$slideInBottom 0.5s ease-out' : 'none',
      animationFillMode: 'forwards',
    },
    '@keyframes slideInBottom': {
      '0%': {
        transform: 'translateY(100%)',
      },
      '100%': {
        transform: 'translateY(0)',
      },
    },
    slideOutBottom: {
      animation: isClosingDown
        ? '$slideOutBottom 1.2s cubic-bezier(0.4, 0, 0.2, 1)'
        : 'none',
      animationFillMode: 'forwards',
    },
    '@keyframes slideOutBottom': {
      '0%': { transform: 'translateY(0)', opacity: 1 },
      '100%': { transform: 'translateY(100%)', opacity: 0 },
    },
  }));
  const classes = useStyles();

  // Function to open the message and set necessary states
  const Openmessage = () => {
    if (issolicitor) {
      setMessage(true);
      setChangestab(true);
    }
    setShowMessage(true);
    setMessagedata({ binderId: isgallery ? binderId : ischatopen });
  };

  const Downarrow = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ pointerEvents: 'none' }}
      >
        <rect
          opacity="0.1"
          x="0.863281"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
        />
        <path
          d="M16.8086 9.11328L10.7158 15.2061L4.62305 9.11328"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          transform="translate(4 3.5)" // Center the path
        />
      </svg>
    );
  };
  // Centered X Icon Component
  const CenteredXIcon = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 31 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ pointerEvents: 'none' }}
      >
        <rect
          opacity="0.1"
          x="0.863281"
          y="0.5"
          width="29"
          height="29"
          rx="4.5"
          stroke="#112347"
          fill="white"
        />
        <line
          x1="10"
          y1="10"
          x2="21"
          y2="20"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="10"
          y1="20"
          x2="21"
          y2="10"
          stroke="#6C2AD2"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    );
  };

  // Function to add current binder to the loop array
  const Addtoloop = async () => {
    await setMoxochatloop((prevArray) => {
      const array = Array.isArray(prevArray) ? prevArray : [];
      // Check if currentBinder already exists in the array
      if (!array.includes(ischatopen)) {
        return [...array, ischatopen];
      }

      return array; // Return the array unchanged if currentBinder is already present
    });
    handleClose('minimize');
  };

  // 1. Define Configuration
  const baseURL = RCP_API_URL;
  const authConfig = {
    orgId: 'Pd7iYEBgFzz1IzINAWois2I',
    uniqueId: USER_MAIL_ID, // User email or unique ID
    userId: MOXO_USER_ID,
    clientId: 'NDY2NGY2OWR',
    clientSecret: 'Y2Y1OTE4NDR',
  };

  // SDK init must run AFTER the component mounts
  useEffect(() => {
    if (!open) return;

    const timer = setTimeout(() => {
      if (!sdkContainerRef.current) return;

      // Destroy previous instance safely
      if (sdkRef.current) {
        try {
          sdkRef.current.destroy();
        } catch (e) {}
        sdkRef.current = null;
      }

      sdkRef.current = init(sdkContainerRef.current, {
        baseURL,
        auth: authConfig,
        isShowChat: true,
        binderId: isgallery ? binderId : ischatopen,
      });
    }, 400); // 🔥 match collapse animation duration

    return () => {
      clearTimeout(timer);

      if (sdkRef.current) {
        try {
          sdkRef.current.destroy();
        } catch (e) {}
        sdkRef.current = null;
      }
    };
  }, []);

  // Don't render anything until we know where to portal to
  if (!mounted || !portalRootRef.current) {
    return null;
  }

  // Scale the entire card to 67% and adjust the width and height accordingly
  const inverse = 1 / APP_SCALE; // Calculate the inverse of the scale for width and height adjustments

  const topOffset =
    primaryUserTypeValue === 'Agent'
      ? matchesxl
        ? 90
        : 80
      : matchesxl
      ? 60
      : 50;

  // Render the card with the Moxo chat inside a portal
  return createPortal(
    <>
      <Collapse in={open || isClosingDown}>
        <Card
          sx={{
            zIndex: 999999,
            position: 'fixed',
            top: `${topOffset}px`,
            right: 0,
            transform: `scale(${APP_SCALE})`,
            transformOrigin: 'top right',
            width: `${inverse * 100}%`,
            height: `calc((100vh - ${topOffset}px) * ${inverse})`,
            maxWidth: matchesxl ? '550px' : '500px',
            backgroundColor: '#345B83',
            display: 'flex',
            flexDirection: 'column',
            padding: '15px',
          }}
        >
          <Grid
            sx={{
              width: '100%',
              height: '50px',
              display: 'flex',
              flexShrink: 0,
              flexGrow: '0 !important',
              zIndex: 30,
              alignItems: 'start',
              justifyContent: 'space-between',
              backgroundColor: '#345B83',
            }}
          >
            <IconButton
              onClick={() => {
                Openmessage();
                handleClose();
              }}
              disableRipple
              sx={{
                backgroundColor: '#ffff',
                borderRadius: '5px',
                padding: '0px',
              }}
            >
              <ExpandIcon />
            </IconButton>
            <Typography className={classes.innericons}>
              {isLargeScreen && !isgallery && (
                <IconButton
                  onClick={() => {
                    Addtoloop();
                  }}
                  disableRipple
                  sx={{
                    backgroundColor: '#ffff',
                    borderRadius: '5px',
                    padding: '0px',
                  }}
                >
                  <Downarrow />
                </IconButton>
              )}
              <IconButton
                onClick={handleClose}
                disableRipple
                sx={{
                  backgroundColor: '#ffff',
                  borderRadius: '5px',
                  padding: '0px',
                }}
              >
                <CenteredXIcon />
              </IconButton>
            </Typography>
          </Grid>

          <CardContent
            sx={{
              padding: 0,
              backgroundColor: '#345B83',
              flex: 1, // ✅ allow flex growth
              minHeight: 0, // ✅ VERY IMPORTANT
              display: 'flex', // ✅ pass height down
            }}
          >
            <Grid
              container
              ref={sdkContainerRef}
              sx={{
                flex: 1,
                minHeight: 0, // 🔥 REQUIRED
                backgroundColor: '#fff',
                overflow: 'hidden',
              }}
              id="moxo-web-sdk-showchat"
            />
          </CardContent>
        </Card>
      </Collapse>
    </>,
    portalRootRef.current
  );
}

export default Moxochat;
